'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import { ENV } from '@lib/env'

// lib
import { formatDateInput, parseDateInput } from '../validators'
import { validateDate, validateDateErrorMessage } from '../validators'
import MaskedField, { MaskedFieldProps } from './masked-field'

/* -----------------------------------------------------------------------------
 * DateField
 * -------------------------------------------------------------------------- */

export type DateFieldProps = Omit<
  MaskedFieldProps,
  'label' | 'nativeMask' | 'webMask'
> & {
  label?: MaskedFieldProps['label']
}

const DateField = ({ required, ...props }: DateFieldProps) => {
  const requiredVal =
    required && typeof required === 'boolean'
      ? validateDateErrorMessage
      : required

  return (
    <MaskedField
      label='Date'
      placeholder='MM-DD-YYYY'
      nativeMask='[00]-[00]-[0000]'
      webMask={[/\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      format={formatDateInput}
      parse={parseDateInput}
      validate={validateDate()}
      required={requiredVal}
      {...(ENV['client_type'] === 'web' ? {} : { keyboardType: 'number-pad' })}
      {...props}
    />
  )
}

export default DateField
